import { Vector3 } from '../_snowpack/pkg/three.js';
import { createSprite } from '../proto/sprite.js';
import { rand } from '../utils/random.js';

/**
 * @param world {LDEngine}
 */
export const init_stars = world => {
  for (let i = 0; i < 200; i++) {
    const pos = new Vector3()
      .randomDirection()
      .setZ(0)
      .normalize()
      .multiplyScalar(rand(1, 500))
      .setZ(rand(-700, -100));

    world.addEntity({
      ...createSprite('img/blank.png'),
      pos,
    });
  }
};
